import { Routes } from '@angular/router';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard, Page404authenticatorComponent } from '@poliblend/polifunzione-lib';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  { path: '', component: WelcomePageComponent },
  { path: 'authenticate', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: '**', component: Page404authenticatorComponent },
];
